import { isBindingContextLoaded } from "../../../common/module-guard";

import { DefaultCanvasPyramid3dRender } from "./pyramid3d-render";

import { GraphicRender, Pyramid3dRender } from "./symbol";

const loadedPyramid3dModuleContexts = new WeakSet;

export function bindPyramid3dRenderModule({bind: bind}) {
    isBindingContextLoaded(loadedPyramid3dModuleContexts, bind) || (bind(DefaultCanvasPyramid3dRender).toDynamicValue((() => new DefaultCanvasPyramid3dRender)).inSingletonScope(), 
    bind(Pyramid3dRender).toService(DefaultCanvasPyramid3dRender), bind(GraphicRender).toService(Pyramid3dRender));
}

export const pyramid3dModule = bindPyramid3dRenderModule;
//# sourceMappingURL=pyramid3d-module.js.map
